import { render, staticRenderFns } from "./ModalLayouts.vue?vue&type=template&id=1ff4b597&scoped=true"
import script from "./ModalLayouts.vue?vue&type=script&lang=js"
export * from "./ModalLayouts.vue?vue&type=script&lang=js"
import style0 from "./ModalLayouts.vue?vue&type=style&index=0&id=1ff4b597&prod&scoped=true&lang=css"
import style1 from "./ModalLayouts.vue?vue&type=style&index=1&id=1ff4b597&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff4b597",
  null
  
)

export default component.exports